import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaAtendimentosDeConsulta } from './types';

export const INITIAL_STATE: ConsultaAtendimentosDeConsulta = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaAtendimentosDeConsulta {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_ATENDIMENTOS_DE_CONSULTA_REQUEST: {
				break;
			}
			case Types.CONSULTA_ATENDIMENTOS_DE_CONSULTA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_ATENDIMENTOS_DE_CONSULTA_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_ATENDIMENTOS_DE_CONSULTA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
